import React from 'react';
import { Clock, CheckCircle, AlertCircle } from 'lucide-react';

interface StatsProps {
  awaitingBids: number;
  inProgress: number;
  noBidsFromUs: number;
}

export function Stats({ awaitingBids, inProgress, noBidsFromUs }: StatsProps) {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
        <Clock className="w-4 h-4 mr-1" />
        Awaiting Bids ({awaitingBids})
      </span>
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
        <CheckCircle className="w-4 h-4 mr-1" />
        In Progress ({inProgress})
      </span>
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
        <AlertCircle className="w-4 h-4 mr-1" />
        No Bids From Us ({noBidsFromUs})
      </span>
    </div>
  );
}